// Camera framing constants.
//
// These values are now used only as boot-time defaults (so the camera
// has somewhere sensible to look before a model has been added to the
// scene) and as the modelY anchor for CharacterPoseConfig.computePose
// (which still snaps each model so its eyes land near world-Y=180 for
// the platform/floor math). The actual per-utterance camera framing —
// target, distance, zoom bounds — is computed dynamically from the
// detected LeftEye / RightEye world positions every time a model is
// committed (see EyeFraming.js + ModelViewer._applyEyeBasedFraming).
// This avoids the stale assumption that floorOffset == 0 for every
// rig, which previously left FBX models showing chest/torso instead
// of the face.
export const SCENE_FRAMING = Object.freeze({
    faceAnchorY: 180,
    cameraPosition: Object.freeze({ x: 0.0, y: 180.0, z: 95.0 }),
    cameraTarget: Object.freeze({ x: 0.0, y: 180.0, z: 0.0 }),
    platformVerticalOffset: 20,
    platformScale: 1.5,
    platformZ: -27,
});
